<template>
  <div class="swiper_inventory_container">
    <div class="container">
      <div> <!-- v-scroll-reveal="{ delay: 50, distance: '20px' }" ---->
        <div>
          <div class="shane_tm_title" style="float: none;">
            <div class="title_flex">
              <div class="">
                <span>Inventory</span>
                <h3>Featured Items</h3>
              </div>
            </div>
          </div>
        </div>
        <br/>
        <VueSlickCarousel :arrows="true" :dots="true" v-bind="settings" style="margin: 20px;">
          <CardInventory
            v-for="(invItem, index) in featuredInventory"
            :key="index"
            :img="invItem.img"
            :imgSmall="invItem.imgSmall"
            :title="invItem.title"
            :desc="invItem.description"
          />
          
        </VueSlickCarousel>
        <!-- <button @click="ViewFull()">View Full Inventory</button> -->
      </div>
    </div>
  </div>
</template>

<script>

import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import VueSlickCarousel from 'vue-slick-carousel'
import CardInventory from "../cards/CardInventory";
// optional style for arrows & dots

export default {
  name: 'MyComponent',
  components: { VueSlickCarousel, CardInventory },
  data() {
    return {
      slidesToShow: 1,
    }
  },
  methods: {
    ViewFull() {
      window.scrollTo(0, 0)
      this.$router.push('/inventory')
    },
    CalculateSlidesToShow() {
      const interval = 300
      const base = 500
      const val = this.windowWidth
      if (val < base) {
        this.slidesToShow = 1
      } else if (val < base + interval) {
        this.slidesToShow = 2
      } else if (val < base + interval * 2) {
        this.slidesToShow = 3
      } else if (val < base + interval * 3) {
        this.slidesToShow = 4
      } else {
        this.slidesToShow = 5
      }
    },
  },
  watch: {
    windowWidth() {
      this.CalculateSlidesToShow()
    }
  },
  computed: {
    windowWidth() {
      return this.$store.getters.GetWindowWidth
    },
    settings() {
      return {
        slidesToShow: this.slidesToShow,
        dots: true,
        dotsClass: "slick-dots custom-dot-class",
        edgeFriction: 0.35,
        infinite: true,
        speed: 750,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        lazyLoad: 'progressive',
      }
    },
    featuredInventory() {
      return this.$store.getters.GetFeaturedInventory
    },
  },
  mounted() {
    setTimeout(() => {
      this.CalculateSlidesToShow()
    }, 200)
  },
}

</script>

<style lang="css">
.swiper_inventory_container {
  margin-top: 50px;
}
</style>